import type { DaemonMachine } from "../api/types.js";

// 2.5.E.2: kone-valitsin /levyt-näkymää varten. Dropdown jos > 1 kone,
// muuten yhden koneen yksinäinen otsake.

export function MachineSelector({
  machines,
  selectedId,
  onSelect,
}: {
  machines: DaemonMachine[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}) {
  if (machines.length === 0) return null;
  if (machines.length === 1) {
    const m = machines[0]!;
    return <MachineHeader machine={m} />;
  }
  return (
    <div className="flex items-center justify-between gap-3">
      <label className="text-sm text-slate-400">
        Kone:
        <select
          value={selectedId ?? ""}
          onChange={(e) => onSelect(e.target.value)}
          className="ml-2 rounded bg-slate-800 px-3 py-1.5 text-sm text-slate-100"
        >
          {machines.map((m) => (
            <option key={m.id} value={m.id}>
              {m.label ?? m.hostname ?? m.id}
            </option>
          ))}
        </select>
      </label>
      {selectedId && (
        <StatusBadge
          status={machines.find((m) => m.id === selectedId)?.status ?? "unknown"}
        />
      )}
    </div>
  );
}

function MachineHeader({ machine }: { machine: DaemonMachine }) {
  return (
    <div className="flex items-center justify-between gap-3">
      <div>
        <h3 className="text-lg font-semibold text-slate-100">
          {machine.label ?? machine.hostname ?? machine.id}
        </h3>
        <p className="text-xs text-slate-500">
          {machine.osPlatform} {machine.osVersion} • {machine.agentVersion}
        </p>
      </div>
      <StatusBadge status={machine.status} />
    </div>
  );
}

function StatusBadge({ status }: { status: "online" | "unknown" | "offline" }) {
  const colors = {
    online: "bg-green-700 text-green-100",
    unknown: "bg-yellow-700 text-yellow-100",
    offline: "bg-red-900 text-red-200",
  };
  return (
    <span
      className={`rounded px-2 py-0.5 text-xs uppercase tracking-wide ${colors[status]}`}
    >
      {status}
    </span>
  );
}
